const MODULE = {
  state: {
    facts: []
  },

  mutations: {
    setFacts (state, facts) {
      state.facts = facts
    }
  },

  actions: {
    requestAllFacts: async (context) => {
      if (context.rootState.challenge.currentlyViewedChallenge !== null) {
        // gets and sets all thoughts for the activated challenge
        const endpoint = '/api/v1/fact'
        const queryParams = {
          challenge: context.rootState.challenge.currentlyViewedChallenge.uuid
        }

        const allFacts = await context.dispatch('authorizedFetch', {
          method: 'GET',
          endpoint: endpoint,
          queryParams: queryParams
        }, { root: true })

        context.commit('setFacts', allFacts.facts)
      }
    },

    requestCreateFact: async (context, text) => {
      const endpoint = '/api/v1/fact'
      const body = {
        challenge: context.rootState.challenge.currentlyViewedChallenge.uuid,
        content: text
      }

      await context.dispatch('authorizedFetch', {
        method: 'POST',
        endpoint: endpoint,
        body: body
      }, { root: true })
    }
  }
}

export default MODULE
